import { FormTypes } from "../enums";

export class FormToSendModel{
    FormID: number;
    FormType: FormTypes;
    Name: string;
    CategoryName: string;
    IsFormContainsTherapistStampField: boolean;
    Selected: boolean;
    
   

    constructor(obj?: any){
        this.FormID = obj && obj.FormID || 0;
        this.FormType = obj && obj.FormType || FormTypes.Undefined;
        this.Name = obj && obj.Name || null;
        this.CategoryName = obj && obj.CategoryName || null;
        this.IsFormContainsTherapistStampField = obj && obj.IsFormContainsTherapistStampField || false;
        this.Selected = obj && obj.Selected || false;
    }

    
}